<header id="page-topbar">
  <div class="layout-width">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box horizontal-logo">
          <a href="" class="logo logo-dark">
            <span class="logo-sm">
              <img src="assets/images/your-logo2.png" alt="" height="60">
            </span>
            <span class="logo-lg">
              <img src="assets/images/your-logo2.png" alt="" height="50">
            </span>
          </a>

          <a href="" class="logo logo-light">
            <span class="logo-sm">
              <img src="assets/images/your-logo2.png" alt="" height="60">
            </span>
            <span class="logo-lg">
              <img src="assets/images/your-logo2.png" alt="" height="50">
            </span>
          </a>
        </div>

        <button type="button" class="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger"
          id="topnav-hamburger-icon" (click)="toggleMobileMenu($event)">
          <span class="hamburger-icon">
            <span></span>
            <span></span>
            <span></span>
          </span>
        </button>
        <div *ngIf="propertyContactsNotifications"
          (click)="openPropertyContactsNotifications(contentContactNotification, propertyContactsNotifications)"
          class="bg-light d-md-block d-none contacts-notification slide-in-left border-0 card mx-2 my-auto shadow-sm">
          <div class="d-flex align-items-center p-2">
            <div
              class="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center me-3 notification-icon">
              <i class="ri-user-star-line fs-22"></i>
            </div>
            <div class="flex-grow-1"></div>
            <div class="fw-semibold text-dark">
              {{
              (propertyContactsNotifications?.contacts?.length ?? 0) > 1
              ? ('t-potential-contacts-text' | translate: {quantity:
              propertyContactsNotifications.contacts?.length ?? 0, reference:
              propertyContactsNotifications.property?.reference})
              : ('t-potential-contacts-text-single' | translate: {quantity:
              propertyContactsNotifications.contacts?.length ?? 0, reference:
              propertyContactsNotifications.property?.reference})
              }}
            </div>
            <button type="button"
              class="align-items-center btn btn-outline-primary btn-notification btn-sm d-flex justify-content-center ms-3 p-0">
              <i class="ri-arrow-right-line"></i>
            </button>
          </div>
          <div class="progress" style="height: 4px;">
            <div class="progress-bar bg-primary" role="progressbar" [style.width.%]="notificationProgress"
              [attr.aria-valuenow]="notificationProgress" aria-valuemin="0" aria-valuemax="100">
            </div>
          </div>
        </div>

      </div>

      <div class="d-flex align-items-center">

        <!-- AI Credit Wallet indicator (kept on the far left of the topbar actions) -->
        <div class="header-item d-none d-sm-flex me-1" *ngIf="aiIndicatorEnabled && canViewAiIntegrations">
          <button type="button" class="btn btn-topbar btn-ghost-secondary ai-wallet-pill" (click)="goToAiCredits()"
            ngbTooltip="AI Créditos" placement="bottom">
            <span class="ai-wallet-pill-icon"><i class="bx bx-bot"></i></span>
          </button>
          <span class="ai-wallet-pill-value ms-1" [class.is-pulsing]="aiBalancePulsing">
            {{ aiAvailableBalance ?? '-' }}
          </span>
          <span class="ai-wallet-pill-burst ms-1" *ngIf="aiBurstAmount !== null">-{{ aiBurstAmount }}</span>
        </div>

        <div class="dropdown d-md-none topbar-head-dropdown header-item" ngbDropdown>
          <button type="button" class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
            id="page-header-search-dropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
            ngbDropdownToggle>
            <i class="bx bx-search fs-22"></i>
          </button>
          <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
            aria-labelledby="page-header-search-dropdown" ngbDropdownMenu>
            <form class="p-3">
              <div class="form-group m-0">
                <div class="input-group">
                  <input type="text" class="form-control" placeholder="Search ..." aria-label="Recipient's username">
                  <button class="btn btn-primary" type="submit"><i class="mdi mdi-magnify"></i></button>
                </div>
              </div>
            </form>
          </div>
        </div>

        <div *ngIf="listLang.length > 0" class="dropdown ms-1 topbar-head-dropdown header-item" ngbDropdown>
          <button type="button" class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
            data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" ngbDropdownToggle>
            <img *ngIf="flagvalue !== undefined" src="{{flagvalue}}" alt="Header Language" height="20" class="rounded">
            <img *ngIf="flagvalue === undefined" src="{{valueset}}" alt="Header Language" height="20" class="rounded">
          </button>
          <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>

            <!-- item-->
            <button type="button" class="dropdown-item notify-item language py-2" data-lang="eng"
              *ngFor="let item of listLang" (click)="onLanguageSelect($event, item)"
              [ngClass]="{'active': cookieValue === item.lang}">
              <img src="{{item.flag}}" alt="user-image" class="me-2 rounded" height="18"> <span
                class="align-middle">{{item.text}}</span>
            </button>
          </div>
        </div>

        <!-- Contexto global de agência (só MASTER, fora do "Ver como"). -->
        <app-agency-context-selector class="ms-1 header-item"
          *ngIf="currentUser.role?.name==='MASTER' && !currentUser?.impersonator">
        </app-agency-context-selector>

        <!-- Seletor antigo de país/agências: substituído pelo de cima, mantido escondido. -->
        <div class="dropdown topbar-head-dropdown ms-1 header-item" #dropdownCountryRef style="display: none"
          *ngIf="currentUser.role?.name==='MASTER'">
          <button type="button" class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
            data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-bs-auto-close="outside"
            id="dropdownCountryRef">
            <i class='ri-building-4-line fs-22'></i>
            <span class="position-absolute topbar-badge fs-10 translate-middle badge rounded-pill bg-info"
              *ngIf="topBarService.countrySelected && topBarService.countrySelected.agencies && topBarService.countrySelected.agencies.length>0">
              {{topBarService.countrySelected.agencies.length }}
              <span class="visually-hidden">unread messages</span></span>
          </button>
          <div class="dropdown-menu dropdown-menu-xl dropdown-menu-end p-0" aria-labelledby="page-header-cart-dropdown">
            <div class="p-3 border-top-0 border-start-0 border-end-0 border-dashed border pb-2">
              <div class="row align-items-center">
                <div class="col-12">
                  <div class="mb-3">
                    <ng-select [items]="countries" [multiple]="false"
                      placeholder="{{ 't-general.t-select' | translate }} {{ 't-m-properties.t-country' | translate }}"
                      bindLabel="name" bindValue="id" (change)=" onChangeCountry($event)"
                      [(ngModel)]="selectedCountryId" (clear)="onClearCountry()">
                    </ng-select>
                  </div>
                </div>
                <div class="col">
                  <h6 class="m-0 fs-16 fw-semibold"> {{ 't-store' | translate }}</h6>
                </div>
                <div class="col-auto">
                  <span class="badge badge-soft-primary fs-13">
                    {{topBarService.countrySelected && topBarService.countrySelected.agencies ?
                    topBarService.countrySelected.agencies.length
                    : 0}}
                  </span>
                </div>
              </div>
            </div>
            <div class="p-2">
              <div class="d-block text-wrap px-2 py-2">
                <ng-select [items]="agencies" [multiple]="true"
                  placeholder="{{ 't-general.t-select' | translate }} {{ 't-store' | translate }}" bindLabel="name"
                  bindValue="id" (change)="onChangeAgency($event)"
                  [ngClass]="{'country-agencies-disabled':!topBarService.countrySelected}"
                  [(ngModel)]="selectedAgenciesId">
                </ng-select>
              </div>
            </div>
            <div class="p-3 border-bottom-0 border-start-0 border-end-0 border-dashed border d-grid">
              <!-- <a href="ecommerce/checkout" class="btn btn-success text-center">
                                Guardar
                            </a> -->
              <div class="row">
                <div class="col-6">
                  <button type="button" class="btn btn-light w-100" (click)="onResetCountry()">
                    {{'t-reset' | translate }}
                  </button>
                </div>
                <div class="col-6">
                  <button type="button" class="btn btn-light w-100"
                    [attr.disabled]="topBarService.checkChanges()?null:true" (click)="closeDropdown()">{{ 't-save' |
                    translate }}</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Simuladores (IMT e crédito): para qualquer imóvel, a qualquer momento. -->
        <div class="ms-1 header-item d-flex">
          <button type="button" class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
            (click)="openSimulators()" [ngbTooltip]="'t-simulators.t-title' | translate" placement="bottom"
            container="body">
            <i class="ri-calculator-line fs-22"></i>
          </button>
        </div>

        <div class="ms-1 header-item d-none d-sm-flex">
          <button type="button" class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
            data-toggle="fullscreen" (click)="fullscreen()">
            <i class='bx bx-fullscreen fs-22'></i>
          </button>
        </div>

        <div class="ms-1 header-item d-none d-sm-flex">
          <button type="button" class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle light-dark-mode">
            <i class='bx bx-moon fs-22' (click)="changeMode('dark')"></i>
            <i class='bx bx-sun fs-22' (click)="changeMode('light')"></i>
          </button>
        </div>

        <!-- notifications button -->
        <div class="dropdown topbar-head-dropdown ms-1 header-item" ngbDropdown>
          <button type="button" class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
            data-bs-auto-close="outside" id="page-header-notifications-dropdown" data-bs-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false" ngbDropdownToggle>
            <i class='bx bx-bell fs-22'></i>

            <span class="position-absolute topbar-badge fs-10 translate-middle badge rounded-pill bg-danger"
              *ngIf="countNotification>0">
              {{countNotification}}
              <span class="visually-hidden">unread messages</span></span>
          </button>

          <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
            aria-labelledby="page-header-notifications-dropdown" ngbDropdownMenu>
            <div class="dropdown-head bg-primary bg-pattern rounded-top">
              <div class="p-3">
                <div class="row align-items-center">
                  <div class="col">
                    <h6 class="m-0 fs-16 fw-semibold text-white">
                      {{'t-notifications'|translate}}
                    </h6>
                  </div>

                  <div class="col-auto dropdown-tabs">
                    <span class="badge badge-soft-light fs-13" *ngIf="countNotification>0">
                      {{countNotification}} {{'t-new'|translate}}</span>
                  </div>
                  <div class="col-auto mt-2">
                    <button type="button" class="btn btn-light btn-sm"
                      [disabled]="markingAllNotificationsAsRead || !hasUnreadNotificationsToMarkAll()"
                      (click)="markAllNotificationsAsRead()">
                      {{'t-mark-all-as-read'|translate}}
                    </button>
                  </div>
                </div>
              </div>

              <div class="px-2 pt-2">
                <ul ngbNav #nav="ngbNav" [activeId]="1" class="nav nav-tabs dropdown-tabs nav-tabs-custom"
                  id="notificationItemsTab">
                  <li [ngbNavItem]="1">
                    <a ngbNavLink>
                      Leads

                      <span class="badge bg-info ms-1" *ngIf="getCountRead('LEADS')>0">
                        {{getCountRead('LEADS')}}
                      </span>

                    </a>
                    <ng-template ngbNavContent>
                      <div class="tab-pane fade show active" id="all-noti-tab" role="tabpanel"
                        [ngClass]="{'p-4':countNotificationLeads===0,'py-2 ps-2':countNotificationLeads>0}">
                        <div class="w-25 w-sm-50 pt-3 mx-auto" *ngIf="countNotificationLeads===0">
                          <img src="assets/images/svg/bell.svg" class="img-fluid" alt="user-pic">
                        </div>
                        <div class="text-center pb-5 mt-2" *ngIf="countNotificationLeads===0">
                          <h6 class="fs-18 fw-semibold lh-base">
                            {{'t-you-have-no-any-leads'|translate}}
                          </h6>
                        </div>
                        <ngx-simplebar style="max-height: 300px;">
                          <div class="pe-2">
                            <ng-container *ngFor="let n of notificationsLeads">
                              <div class="text-reset notification-item d-block dropdown-item position-relative"
                                *ngIf="n.type==='LEADS' || n.type ==='LEAD_ASSIGNMENT'" [ngClass]="{'active':!n.read}"
                                (click)="updateNotificationToRead(n)">
                                <div class="d-flex">
                                  <div class="avatar-xs me-3">
                                    <span class="avatar-title bg-soft-info text-info rounded-circle fs-16">
                                      <i [ngClass]="{'ri-mail-unread-line':!n.read,' ri-mail-check-line':n.read}">
                                      </i>
                                    </span>
                                  </div>
                                  <div class="flex-1">
                                    <a href="javascript:void(0);" class="stretched-link">
                                      <h6 class="mt-0 mb-2 lh-base" *ngIf="n.type==='LEAD_ASSIGNMENT'">
                                        {{ getLeadAssignmentTitleKey(n.statusNotification) | translate }}
                                      </h6>
                                      <h6 class="mt-0 mb-2 lh-base" *ngIf="n.type==='LEADS'">
                                        Lead {{n.eventType}} {{n.title}}
                                      </h6>
                                    </a>
                                    <div class="fs-13 text-muted">
                                      <p class="mb-1 break-line"
                                        *ngIf="n.type==='LEAD_ASSIGNMENT' && n.statusNotification === 't-deals-referral-notification-assigned' && n.createdBy">
                                        <i class="ri-user-line me-2 align-middle text-muted fs-16"></i>
                                        {{'t-deals-referral-contact-referred-by' | translate: {name: n.createdBy} }}
                                      </p>
                                      <p class="mb-1 break-line" *ngIf="n.email">
                                        <i class="ri-mail-line me-2 align-middle text-muted fs-16"></i>
                                        {{n.email}}
                                      </p>
                                      <p class="mb-1 break-line" *ngIf="n.phone">
                                        <i class="ri-phone-line me-2 align-middle text-muted fs-16"></i>
                                        {{n.phone}}
                                      </p>
                                    </div>

                                    <p class="mb-0 fs-11 fw-medium text-uppercase text-muted">
                                      <span>
                                        <i class="mdi mdi-clock-outline"></i>
                                        <!-- {{createDateFormat(n.createdAt)}} -->
                                        <ng-container
                                          *ngIf="['t-second-ago','t-seconds-ago'].includes(dateFormate(n.createdAt).txt)">
                                          {{'t-now'|translate}}
                                        </ng-container>

                                        <ng-container
                                          *ngIf="!['t-second-ago','t-seconds-ago'].includes(dateFormate(n.createdAt).txt)">
                                          {{
                                          dateFormate(n.createdAt).txt |
                                          translate:{value:''+dateFormate(n.createdAt).val}
                                          }}
                                        </ng-container>

                                      </span>
                                    </p>
                                  </div>
                                  <div class="px-2 fs-15">
                                    <i class="mdi mdi-checkbox-blank-circle me-2 "
                                      [ngClass]="{'text-info':!n.read,'text-white':n.read}"></i>
                                  </div>

                                </div>
                              </div>
                            </ng-container>

                            <div class="my-3 text-center d-none" *ngIf="countNotificationLeads>0">
                              <button type="button" class="btn btn-soft-success waves-effect waves-light">View
                                All Notifications <i class="ri-arrow-right-line align-middle"></i></button>
                            </div>
                          </div>
                        </ngx-simplebar>
                      </div>
                    </ng-template>
                  </li>

                  <li [ngbNavItem]="2" [ngClass]="{'d-none':currentUser?.role.name!=='AGENT'}">
                    <a ngbNavLink>
                      <!-- {{'t-messages'|translate}} -->
                      Chat
                      <span class="badge bg-info ms-1" *ngIf="getCountRead('MESSAGES')>0">
                        {{ getCountRead('MESSAGES')}}
                      </span>
                    </a>

                    <ng-template ngbNavContent>
                      <div class="tab-pane fade show active py-2 ps-2" id="all-noti-tab" role="tabpanel"
                        [ngClass]="{'p-4':countNotificationMessages===0,'py-2 ps-2':countNotificationMessages>0}">
                        <div class="w-25 w-sm-50 pt-3 mx-auto" *ngIf="countNotificationMessages===0">
                          <img src="assets/images/svg/bell.svg" class="img-fluid" alt="user-pic">
                        </div>
                        <div class="text-center pb-5 mt-2" *ngIf="countNotificationMessages===0">
                          <h6 class="fs-18 fw-semibold lh-base">
                            {{'t-you-have-no-any-message'|translate}}
                          </h6>
                        </div>
                        <ngx-simplebar style="max-height: 300px;">
                          <div class="pe-2">
                            <ng-container *ngFor="let n of notificationsMessages">
                              <div class="text-reset notification-item d-block dropdown-item"
                                [ngClass]="{'active':n.unread}" (click)="updateNotificationMessageToRead(n)">
                                <div class="d-flex">
                                  <!-- <img src="{{pathProfileImage}}{{n.user?.profile}}"
                                                                        class="me-3 rounded-circle avatar-xs"
                                                                        alt="user-pic" *ngIf="n.user?.profile">
                                                                    <div class="avatar-xs me-3"
                                                                        *ngIf="!n.user?.profile">
                                                                        <span
                                                                            class="avatar-title rounded-circle bg-danger userprofile">
                                                                            {{ n.user?.name?.charAt(0) }}
                                                                        </span>
                                                                        
                                                                    </div> -->
                                  <div class="flex-shrink-0 chat-user-img {{n.status}} me-2 ms-0">
                                    <div class="avatar-xs" *ngIf="n.user?.profile">
                                      <img src="{{pathProfileImage}}{{n.user?.profile}}"
                                        class="rounded-circle img-fluid userprofile" alt="">
                                    </div>
                                    <div class="avatar-xs" *ngIf="!n.user?.profile">
                                      <span
                                        class="avatar-title rounded-circle bg-soft-info text-info userprofile fs-16">
                                        {{ n.user?.name?.charAt(0) }}
                                      </span>
                                    </div>
                                    <span class="mb-4 user-status"></span>
                                  </div>

                                  <div class="flex-1">
                                    <a href="javascript:void(0);" class="stretched-link">
                                      <h6 class="mt-0 mb-1 fs-13 fw-semibold">
                                        {{n.user?.name}}
                                      </h6>
                                    </a>
                                    <div class="fs-13 text-muted text-truncate-lines-custom" *ngIf="!n.files">
                                      <p class="mb-1">
                                        {{n.message}}
                                      </p>
                                    </div>
                                    <div class="fs-13 text-muted" *ngIf="n.files">
                                      <p class="mb-1">
                                        <i class="ri-folder-zip-line"></i>
                                        {{n.files}}
                                        {{n.files==1?('t-file'|translate):('t-files'|translate)}}
                                      </p>

                                    </div>
                                    <p class="mb-0 fs-11 fw-medium text-uppercase text-muted">
                                      <span>
                                        <i class="mdi mdi-clock-outline"></i>

                                        <ng-container
                                          *ngIf="['t-second-ago','t-seconds-ago'].includes(dateFormate(n.time).txt)">
                                          {{'t-now'|translate}}
                                        </ng-container>
                                        <ng-container
                                          *ngIf="!['t-second-ago','t-seconds-ago'].includes(dateFormate(n.time).txt)">
                                          {{
                                          dateFormate(n.time).txt |
                                          translate:{value:''+dateFormate(n.time).val}
                                          }}
                                        </ng-container>
                                      </span>
                                    </p>
                                  </div>

                                  <div class="px-2 fs-15">
                                    <!-- <i class="mdi mdi-checkbox-blank-circle me-2 "
                                                                            [ngClass]="{'text-info':n.unread,'text-white':!n.unread}">
                                                                            {{n.countUnRead}}
                                                                        </i> -->

                                    <span class="badge bg-info ms-1 rounded-circle" *ngIf="n.unread">
                                      {{n.countUnRead<10?n.countUnRead:'+9'}} </span>

                                  </div>
                                </div>
                              </div>
                            </ng-container>

                            <div class="my-3 text-center" *ngIf="countNotificationMessages===10">
                              <a routerLink="/chat" class="btn btn-soft-success waves-effect waves-light">
                                {{'t-view-more'|translate}} <i class="ri-arrow-right-line align-middle"></i></a>
                            </div>
                          </div>
                        </ngx-simplebar>
                      </div>
                    </ng-template>
                  </li>

                  <li [ngbNavItem]="3">
                    <a ngbNavLink>
                      {{'t-alerts'|translate}}
                      <span class="badge bg-info ms-1" *ngIf="getCountRead('ALERT')>0">
                        {{getCountRead('ALERT')}}
                      </span>
                    </a>

                    <ng-template ngbNavContent>
                      <div class="tab-pane " id="alerts-tab" role="tabpanel" aria-labelledby="alerts-tab"
                        [ngClass]="{'p-4':countNotificationAlers===0,'py-2 ps-2':countNotificationAlers>0}">
                        <div class="w-25 w-sm-50 pt-3 mx-auto" *ngIf="countNotificationAlers===0">
                          <img src="assets/images/svg/bell.svg" class="img-fluid" alt="user-pic">
                        </div>

                        <div class="text-center pb-5 mt-2" *ngIf="countNotificationAlers===0">
                          <h6 class="fs-18 fw-semibold lh-base">
                            {{'t-you-have-no-any-alert'|translate}}
                          </h6>
                        </div>

                        <ngx-simplebar style="max-height: 300px;">
                          <div class="pe-2">
                            <ng-container *ngFor="let n of notificationsAlers">
                              <div class="text-reset notification-item d-block dropdown-item position-relative"
                                *ngIf="n.type==='CALENDAR_EVENT'" [ngClass]="{'active':!n.read}"
                                (click)="updateNotificationToRead(n)">
                                <div class="d-flex">
                                  <div class="avatar-xs me-3">
                                    <span class="avatar-title bg-soft-info text-info rounded-circle fs-16">
                                      <i class="ri-calendar-event-line"></i>
                                    </span>
                                  </div>

                                  <div class="flex-1">
                                    <a href="javascript:void(0);" class="stretched-link">
                                      <h6 class="mt-0 mb-2 lh-base">
                                        {{n?.startAt | amLocale:langValue |
                                        amDateFormat:'LT'}} -
                                        {{n?.endAt | amLocale:langValue |
                                        amDateFormat:'LT'}}
                                        {{n.eventType}}
                                      </h6>
                                    </a>

                                    <div class="fs-13 text-muted">
                                      <p class="mb-1">
                                        <!-- {{n.message}} -->
                                        {{n.title}} {{n?.startAt |
                                        amLocale:langValue |
                                        amDateFormat:'LLLL'}}
                                      </p>
                                    </div>

                                    <p class="mb-0 fs-11 fw-medium text-uppercase text-muted">
                                      <span>
                                        <i class="mdi mdi-clock-outline"></i>
                                        <ng-container
                                          *ngIf="['t-second-ago','t-seconds-ago'].includes(dateFormate(n.createdAt).txt)">
                                          {{'t-now'|translate}}
                                        </ng-container>
                                        <ng-container
                                          *ngIf="!['t-second-ago','t-seconds-ago'].includes(dateFormate(n.createdAt).txt)">
                                          {{
                                          dateFormate(n.createdAt).txt |
                                          translate:{value:''+dateFormate(n.createdAt).val}
                                          }}
                                        </ng-container>
                                      </span>
                                    </p>
                                  </div>

                                  <div class="px-2 fs-15">
                                    <i class="mdi mdi-checkbox-blank-circle me-2 "
                                      [ngClass]="{'text-info':!n.read,'text-white':n.read}">
                                    </i>
                                  </div>
                                </div>
                              </div>

                              <div class="text-reset notification-item d-block dropdown-item position-relative"
                                *ngIf="n.type==='MEDIATION_AGREEMENT'" [ngClass]="{'active':!n.read}"
                                (click)="updateNotificationToRead(n)">
                                <div class="d-flex">
                                  <div class="avatar-xs me-3">
                                    <span class="avatar-title bg-soft-info text-info rounded-circle fs-16">
                                      <i class="ri-calendar-event-line">
                                      </i>
                                    </span>
                                  </div>
                                  <div class="flex-1">
                                    <a href="javascript:void(0);" class="stretched-link">
                                      <h6 class="mt-0 mb-2 lh-base">
                                        {{ n.message === 't-notification-cmi-signed' ? ('t-cmi-signed-title' | translate) : n.message === 't-notification-owner-document-submitted' ? ('t-owner-portal-notification-title' | translate) : n.eventType }}<ng-container *ngIf="n.ref"> - {{n.ref}}</ng-container>
                                      </h6>
                                    </a>
                                    <div class="fs-13 text-muted">
                                      <p class="mb-1">
                                        {{n.message! | translate : {reference :
                                        n.ref} }}
                                      </p>
                                      <!-- <p>  {{n.message! | translate : {reference : n.ref} }}</p> -->
                                      <p class="mb-1">
                                        <!-- <ng-container
                                                                                    *ngIf="compareDate1WithNow(n.endAt)">
                                                                                    {{'t-the-mediation-agreement-has-now-expired'|translate}}
                                                                                </ng-container>
                                                                                <ng-container
                                                                                    *ngIf="!compareDate1WithNow(n.endAt)">
                                                                                    {{'t-mediation-agreement-expire-on'|translate}}
                                                                                    {{n?.endAt |
                                                                                    amLocale:langValue |
                                                                                    amDateFormat:'LL'}}
                                                                                </ng-container> -->
                                        <!-- {{n.message| translate : {reference : n.reference} }} -->
                                      </p>
                                    </div>
                                    <p class="mb-0 fs-11 fw-medium text-uppercase text-muted">
                                      <span>
                                        <i class="mdi mdi-clock-outline"></i>
                                        <ng-container
                                          *ngIf="['t-second-ago','t-seconds-ago'].includes(dateFormate(n.createdAt).txt)">
                                          {{'t-now'|translate}}
                                        </ng-container>
                                        <ng-container
                                          *ngIf="!['t-second-ago','t-seconds-ago'].includes(dateFormate(n.createdAt).txt)">
                                          {{
                                          dateFormate(n.createdAt).txt |
                                          translate:{value:''+dateFormate(n.createdAt).val}
                                          }}
                                        </ng-container>
                                      </span>
                                    </p>
                                  </div>
                                  <div class="px-2 fs-15">
                                    <i class="mdi mdi-checkbox-blank-circle me-2 "
                                      [ngClass]="{'text-info':!n.read,'text-white':n.read}">
                                    </i>

                                  </div>

                                </div>
                              </div>

                              <div class="text-reset notification-item d-block dropdown-item position-relative"
                                *ngIf="n.type==='MEDIATION_AGREEMENT'" [ngClass]="{'active':!n.read}"
                                (click)="updateNotificationToRead(n)">
                                <div class="d-flex">
                                  <div class="avatar-xs me-3">
                                    <span class="avatar-title bg-soft-info text-info rounded-circle fs-16">
                                      <i class="ri-calendar-event-line">
                                      </i>
                                    </span>
                                  </div>
                                  <div class="flex-1">
                                    <a href="javascript:void(0);" class="stretched-link">
                                      <h6 class="mt-0 mb-2 lh-base">
                                        {{ n.message === 't-notification-cmi-signed' ? ('t-cmi-signed-title' | translate) : n.message === 't-notification-owner-document-submitted' ? ('t-owner-portal-notification-title' | translate) : n.eventType }}<ng-container *ngIf="n.ref"> - {{n.ref}}</ng-container>
                                      </h6>
                                    </a>
                                    <div class="fs-13 text-muted">
                                      <p class="mb-1">
                                        {{n.message! | translate : {reference :
                                        n.ref} }}
                                      </p>
                                      <!-- <p>  {{n.message! | translate : {reference : n.ref} }}</p> -->
                                      <p class="mb-1">
                                        <!-- <ng-container
                                                                                    *ngIf="compareDate1WithNow(n.endAt)">
                                                                                    {{'t-the-mediation-agreement-has-now-expired'|translate}}
                                                                                </ng-container>
                                                                                <ng-container
                                                                                    *ngIf="!compareDate1WithNow(n.endAt)">
                                                                                    {{'t-mediation-agreement-expire-on'|translate}}
                                                                                    {{n?.endAt |
                                                                                    amLocale:langValue |
                                                                                    amDateFormat:'LL'}}
                                                                                </ng-container> -->
                                        <!-- {{n.message| translate : {reference : n.reference} }} -->
                                      </p>
                                    </div>
                                    <p class="mb-0 fs-11 fw-medium text-uppercase text-muted">
                                      <span>
                                        <i class="mdi mdi-clock-outline"></i>
                                        <ng-container
                                          *ngIf="['t-second-ago','t-seconds-ago'].includes(dateFormate(n.createdAt).txt)">
                                          {{'t-now'|translate}}
                                        </ng-container>
                                        <ng-container
                                          *ngIf="!['t-second-ago','t-seconds-ago'].includes(dateFormate(n.createdAt).txt)">
                                          {{
                                          dateFormate(n.createdAt).txt |
                                          translate:{value:''+dateFormate(n.createdAt).val}
                                          }}
                                        </ng-container>
                                      </span>
                                    </p>
                                  </div>
                                  <div class="px-2 fs-15">
                                    <i class="mdi mdi-checkbox-blank-circle me-2 "
                                      [ngClass]="{'text-info':!n.read,'text-white':n.read}">
                                    </i>

                                  </div>

                                </div>
                              </div>

                              <div class="text-reset notification-item d-block dropdown-item position-relative"
                                *ngIf="n.type==='MEDIATION_AGREEMENT'" [ngClass]="{'active':!n.read}"
                                (click)="updateNotificationToRead(n)">
                                <div class="d-flex">
                                  <div class="avatar-xs me-3">
                                    <span class="avatar-title bg-soft-info text-info rounded-circle fs-16">
                                      <i class="ri-calendar-event-line">
                                      </i>
                                    </span>
                                  </div>
                                  <div class="flex-1">
                                    <a href="javascript:void(0);" class="stretched-link">
                                      <h6 class="mt-0 mb-2 lh-base">
                                        {{ n.message === 't-notification-cmi-signed' ? ('t-cmi-signed-title' | translate) : n.message === 't-notification-owner-document-submitted' ? ('t-owner-portal-notification-title' | translate) : n.eventType }}<ng-container *ngIf="n.ref"> - {{n.ref}}</ng-container>
                                      </h6>
                                    </a>
                                    <div class="fs-13 text-muted">
                                      <p class="mb-1">
                                        {{n.message! | translate : {reference : n.ref} }}
                                      </p>
                                      <!-- <p>  {{n.message! | translate : {reference : n.ref} }}</p> -->
                                      <p class="mb-1">
                                        <!-- <ng-container
                                                                                    *ngIf="compareDate1WithNow(n.endAt)">
                                                                                    {{'t-the-mediation-agreement-has-now-expired'|translate}}
                                                                                </ng-container>
                                                                                <ng-container
                                                                                    *ngIf="!compareDate1WithNow(n.endAt)">
                                                                                    {{'t-mediation-agreement-expire-on'|translate}}
                                                                                    {{n?.endAt |
                                                                                    amLocale:langValue |
                                                                                    amDateFormat:'LL'}}
                                                                                </ng-container> -->
                                        <!-- {{n.message| translate : {reference : n.reference} }} -->
                                      </p>
                                    </div>
                                    <p class="mb-0 fs-11 fw-medium text-uppercase text-muted">
                                      <span>
                                        <i class="mdi mdi-clock-outline"></i>
                                        <ng-container
                                          *ngIf="['t-second-ago','t-seconds-ago'].includes(dateFormate(n.createdAt).txt)">
                                          {{'t-now'|translate}}
                                        </ng-container>
                                        <ng-container
                                          *ngIf="!['t-second-ago','t-seconds-ago'].includes(dateFormate(n.createdAt).txt)">
                                          {{
                                          dateFormate(n.createdAt).txt |
                                          translate:{value:''+dateFormate(n.createdAt).val}
                                          }}
                                        </ng-container>
                                      </span>
                                    </p>
                                  </div>
                                  <div class="px-2 fs-15">
                                    <i class="mdi mdi-checkbox-blank-circle me-2 "
                                      [ngClass]="{'text-info':!n.read,'text-white':n.read}">
                                    </i>

                                  </div>

                                </div>
                              </div>
                              <div class="text-reset notification-item d-block dropdown-item position-relative"
                                *ngIf="n.type==='PORTAL_ALERTS'" [ngClass]="{'active':!n.read}"
                                (click)="updateNotificationToRead(n)">
                                <div class="d-flex">
                                  <div class="avatar-xs me-3">
                                    <span class="avatar-title bg-soft-info text-info rounded-circle fs-16">
                                      <i class="ri-share-line">
                                      </i>
                                    </span>
                                  </div>
                                  <div class="flex-1">
                                    <a href="javascript:void(0);" class="stretched-link">
                                      <h6 *ngIf="n?.message && n?.message !== 't-portal.t-export-errors'"
                                        class="mt-0 mb-2 lh-base">
                                        {{n.message! | translate}}
                                      </h6>
                                      <h6 *ngIf="n?.message && n?.message == 't-portal.t-export-errors'"
                                        class="mt-0 mb-2 lh-base">
                                        {{n.message! | translate : {portal:
                                        n?.portalName} }}
                                      </h6>
                                    </a>
                                    <!-- <div *ngIf="n?.message" class="fs-13 text-muted">
                                                                            <p class="mb-1">
                                                                                {{n.message! | translate}}
                                                                            </p>
                                                                        </div> -->
                                    <p class="mb-0 fs-11 fw-medium text-uppercase text-muted">
                                      <span>
                                        <i class="mdi mdi-clock-outline"></i>
                                        <ng-container
                                          *ngIf="['t-second-ago','t-seconds-ago'].includes(dateFormate(n.createdAt).txt)">
                                          {{'t-now'|translate}}
                                        </ng-container>

                                        <ng-container
                                          *ngIf="!['t-second-ago','t-seconds-ago'].includes(dateFormate(n.createdAt).txt)">
                                          {{ dateFormate(n.createdAt).txt | translate :
                                          {value:''+dateFormate(n.createdAt).val} }}
                                        </ng-container>
                                      </span>
                                    </p>
                                  </div>

                                  <div class="px-2 fs-15">
                                    <i class="mdi mdi-checkbox-blank-circle me-2 "
                                      [ngClass]="{'text-info':!n.read,'text-white':n.read}">
                                    </i>
                                  </div>
                                </div>
                              </div>

                              <!-- PROPOSALS -->
                              <div class="text-reset notification-item d-block dropdown-item position-relative"
                                *ngIf="n.type === 'PROPOSALS'" [ngClass]="{'active':!n.read}"
                                (click)="updateNotificationToRead(n)">
                                <div class="d-flex">
                                  <div class="avatar-xs me-3">
                                    <span class="avatar-title bg-soft-info text-info rounded-circle fs-16">
                                      <i [ngClass]="{ 'ri-hand-coin-line': n.type === 'PROPOSALS'}"></i>
                                    </span>
                                  </div>

                                  <div class="flex-1">
                                    <a href="javascript:void(0);" class="stretched-link">
                                      <h6 *ngIf="n?.message" class="mt-0 mb-2 lh-base">
                                        {{ n.message! | translate : { reference: n.reference } }}
                                      </h6>
                                    </a>

                                    <p class="mb-0 fs-11 fw-medium text-uppercase text-muted">
                                      <span>
                                        <ng-container
                                          *ngIf="['t-second-ago','t-seconds-ago'].includes(dateFormate(n.createdAt).txt)">
                                          {{'t-now'|translate}}
                                        </ng-container>

                                        <ng-container
                                          *ngIf="!['t-second-ago','t-seconds-ago'].includes(dateFormate(n.createdAt).txt)">
                                          {{ dateFormate(n.createdAt).txt | translate :
                                          {value: '' + dateFormate(n.createdAt).val} }}
                                        </ng-container>
                                      </span>
                                    </p>
                                  </div>

                                  <div class="px-2 fs-15">
                                    <i class="mdi mdi-checkbox-blank-circle me-2 "
                                      [ngClass]="{'text-info':!n.read,'text-white':n.read}">
                                    </i>
                                  </div>
                                </div>
                              </div>

                              <!-- PROPERTIES -->
                              <div class="text-reset notification-item d-block dropdown-item position-relative"
                                *ngIf="n.type === 'PROPERTIES'" [ngClass]="{'active':!n.read}"
                                (click)="updateNotificationToRead(n)">
                                <div class="d-flex">
                                  <div class="avatar-xs me-3">
                                    <span class="avatar-title bg-soft-info text-info rounded-circle fs-16">
                                      <i [ngClass]="{
                                        'ri-home-3-line': n.message === 't-notification-property-validate'
                                          || n.message === 't-notification-property-minimum-commission-validate',
                                        'ri-checkbox-circle-line': n.message === 't-notification-property-approved'
                                          || n.message === 't-notification-property-minimum-commission-approved',
                                        'ri-close-circle-line':
                                          n.message !== 't-notification-property-validate'
                                          && n.message !== 't-notification-property-minimum-commission-validate'
                                          && n.message !== 't-notification-property-approved'
                                          && n.message !== 't-notification-property-minimum-commission-approved'
                                      }"></i>
                                    </span>
                                  </div>

                                  <div class="flex-1">
                                    <a href="javascript:void(0);" class="stretched-link">
                                      <h6 *ngIf="n?.message" class="mt-0 mb-2 lh-base">
                                        {{ n.message! | translate : { reference: n?.reference,
                                        agent: n?.agent, approver: n?.approver } }}
                                      </h6>
                                    </a>

                                    <p class="mb-0 fs-11 fw-medium text-uppercase text-muted">
                                      <span>
                                        <ng-container
                                          *ngIf="['t-second-ago','t-seconds-ago'].includes(dateFormate(n.createdAt).txt)">
                                          {{'t-now'|translate}}
                                        </ng-container>

                                        <ng-container
                                          *ngIf="!['t-second-ago','t-seconds-ago'].includes(dateFormate(n.createdAt).txt)">
                                          {{ dateFormate(n.createdAt).txt | translate :
                                          {value: '' + dateFormate(n.createdAt).val} }}
                                        </ng-container>
                                      </span>
                                    </p>
                                  </div>

                                  <div class="px-2 fs-15">
                                    <i class="mdi mdi-checkbox-blank-circle me-2 "
                                      [ngClass]="{'text-info':!n.read,'text-white':n.read}">
                                    </i>
                                  </div>
                                </div>
                              </div>
                            </ng-container>

                            <div class="my-3 text-center d-none" *ngIf="countNotificationAlers > 0">
                              <button type="button" class="btn btn-soft-success waves-effect waves-light">
                                View All Notifications
                                <i class="ri-arrow-right-line align-middle"></i>
                              </button>
                            </div>
                          </div>
                        </ngx-simplebar>
                      </div>
                    </ng-template>
                  </li>
                </ul>
              </div>
            </div>

            <div class="tab-content" id="notificationItemsTabContent">
              <div class="tab-content text-muted">
                <div [ngbNavOutlet]="nav"></div>
              </div>
            </div>
          </div>
        </div>

        <!-- "Ver como" ativo: o MASTER está a ver o sistema como outro utilizador (só leitura, salvo entidades com canWrite) -->
        <div *ngIf="currentUser?.impersonator" class="d-flex align-items-center ms-2">
          <span class="badge bg-warning text-dark fs-12 d-flex align-items-center">
            <i class="ri-eye-line me-1"></i>
            <span class="d-none d-md-inline">{{ (currentUser?.impersonator?.canWrite ? 't-impersonate-banner-write' : 't-impersonate-banner') | translate: { value: currentUser?.name } }}</span>
          </span>
          <button type="button" class="btn btn-sm btn-soft-warning ms-2 text-nowrap" (click)="stopImpersonation()">
            <i class="ri-eye-off-line align-middle me-1"></i>{{ 't-impersonate-back' | translate }}
          </button>
        </div>

        <div class="dropdown ms-sm-3 header-item topbar-user" ngbDropdown>
          <button type="button" class="btn" id="page-header-user-dropdown" data-bs-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false" ngbDropdownToggle>
            <span class="d-flex align-items-center">
              <img class="rounded-circle header-profile-user"
                [src]="currentUser?.userFiles[0]?.fileName ? pathProfileImage+currentUser.userFiles[0].fileName : 'assets/images/users/user-dummy-img.jpg'"
                alt="Header Avatar">

              <span class="text-start ms-xl-2">
                <span class="d-none d-xl-inline-block ms-1 fw-medium user-name-text">{{currentUser?.name}}</span>

                <span class="d-none d-xl-block ms-1 fs-12 text-muted user-name-sub-text">{{currentUser?.role?.name !==
                  'MASTER' && currentUser?.role?.name !== 'ADMIN' ? currentUser?.roleForEntity?.name :
                  currentUser?.role?.name}}</span>
              </span>
            </span>
          </button>

          <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
            <h6 class="dropdown-header">{{'t-welcome' | translate}} {{currentUser?.name}}!</h6>

            <a *ngIf="currentUser?.role.name !== 'MASTER' && currentUser?.role.name !== 'ADMIN' && permissionsService.hasPermission('EDIT_PROFILE')"
              class="dropdown-item" routerLink="/profile">
              <i class="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i>

              <span class="align-middle">{{"t-profile" | translate}}</span>
            </a>

            <a *ngIf="currentUser?.supportUser && currentUser?.role.name !== 'ADMIN'"
              class="dropdown-item cursor-pointer" (click)="supportBack()">
              <i class="ri-eye-off-line text-muted fs-16 align-middle me-1"></i>

              <span class="align-middle">{{'t-leave-see-as' | translate}}</span>
            </a>

            <a *ngIf="(currentUser?.role.name === 'MASTER' || (currentUser?.supportUser && currentUser?.role.name !== 'ADMIN')) && !currentUser?.impersonator"
              class="dropdown-item cursor-pointer" (click)="openImpersonation()">
              <i class="ri-eye-line text-muted fs-16 align-middle me-1"></i>

              <span class="align-middle">{{'t-impersonate' | translate}}</span>
            </a>

            <a *ngIf="currentUser?.impersonator" class="dropdown-item cursor-pointer" (click)="stopImpersonation()">
              <i class="ri-eye-off-line text-muted fs-16 align-middle me-1"></i>

              <span class="align-middle">{{'t-impersonate-back' | translate}}</span>
            </a>

            <a class="d-none dropdown-item" href="apps/chat">
              <i class="mdi mdi-message-text-outline text-muted fs-16 align-middle me-1"></i>

              <span class="align-middle">{{"t-messages" | translate}}</span>
            </a>

            <a class="d-none dropdown-item" href="pages/faqs">
              <i class="mdi mdi-lifebuoy text-muted fs-16 align-middle me-1"></i>
              <span class="align-middle">Help</span>
            </a>

            <div class="d-none dropdown-divider"></div>

            <a class="d-none dropdown-item" href="pages/profile">
              <i class="mdi mdi-cog-outline text-muted fs-16 align-middle me-1"></i>
              <span class="align-middle">Settings</span>
            </a>

            <a class="d-none dropdown-item" href="auth/lockscreen/basic">
              <i class="mdi mdi-lock text-muted fs-16 align-middle me-1"></i>
              <span class="align-middle">Lock screen</span>
            </a>

            <a *ngIf="currentUser?.role.name === 'MASTER' || currentUser?.role.name === 'STORE OPERATOR'"
              class="dropdown-item" routerLink="/activity-logs">
              <i class="mdi mdi-chart-timeline-variant text-muted fs-16 align-middle me-2"></i>

              <span class="align-middle">{{ "t-logs" | translate}}</span>
            </a>

            <a class="dropdown-item" href="javascript: void(0);" (click)="logout()">
              <i class="mdi mdi-logout text-muted fs-16 align-middle me-1"></i>

              <span class="align-middle" data-key="t-logout">Logout</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>

<ng-template #contentExchange role="document" let-modal>
  <div class="modal-header bg-light  p-3">
    <h5 class="modal-title" id="topModalLabel">{{'t-exchange.t-exchange-used' | translate}}</h5>

    <button type="button" class="btn-close " (click)="modal.dismiss('Cross click')">
    </button>
  </div>

  <div class="modal-body" *ngIf="exchanges">
    <div class="table-responsive table-card">
      <table class="table">
        <thead>
          <tr class="bg-light text-muted">
            <th class="col-4">{{'t-exchange.t-currency' | translate}}
            </th>
            <th class="col-4">{{'t-exchange.t-exchange-rate' | translate}}
            </th>
            <th class="col-4">{{'t-exchange.t-date' | translate}}
            </th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let currency of exchanges">
            <td>{{currency.currencyCode}}</td>
            <td>{{currency.exchangeRate}}</td>
            <td>{{currency.exchangeDate | date: 'dd-MM-yyyy HH:mm'}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</ng-template>

<ng-template #contenttop role="document" let-modal>

  <div class="modal-header bg-light  p-3">
    <h5 class="modal-title" id="topModalLabel" *ngIf="isPortalAlert">
      {{'t-properties-with-errors-when-exporting-to' | translate}}
      {{portalExportError.name}}
    </h5>
    <h5 class="modal-title" id="topModalLabel" *ngIf="!isPortalAlert">
      {{portalExportError.name}} - {{'t-exported-properties' | translate}}

    </h5>
    <button type="button" class="btn-close " (click)="modalRef.dismiss()">
    </button>
  </div>
  <div class="modal-body" *ngIf="portalExportError?.status && isPortalAlert">
    <app-list [portalExportError]="portalExportError" *ngIf="portalExportError?.status">
    </app-list>
  </div>
  <div class="modal-body" *ngIf="portalExportError?.status && !isPortalAlert">

    <ul ngbNav #portalSendPropertiesNav="ngbNav" [(activeId)]="nabTabActive" (activeIdChange)="activeIdChangeNabTab()"
      class="nav nav-tabs-custom rounded card-header-tabs mb-0">
      <li [ngbNavItem]="1">
        <a ngbNavLink>
          {{'t-exported' | translate}}
          <span class="badge badge-soft-success align-middle rounded-pill ms-1">
            {{totalExport.totalexp}}
          </span>
        </a>
        <ng-template ngbNavContent>
          <!-- <div class="modal-body"> -->
          <app-list [portalExportError]="portalExportError"
            *ngIf="portalExportError?.status && portalExportError?.isExported">
          </app-list>
          <!-- </div> -->
        </ng-template>
      </li>
      <li [ngbNavItem]="2">
        <a ngbNavLink>
          {{'t-not-exported' | translate}}
          <span class="badge badge-soft-danger align-middle rounded-pill ms-1">
            {{totalExport.totalNotexp}}
          </span>
        </a>
        <ng-template ngbNavContent>
          <app-list [portalExportError]="portalExportError"
            *ngIf="portalExportError?.status && !portalExportError?.isExported">
          </app-list>
        </ng-template>
      </li>
    </ul>
    <div class="row">
      <div class="tab-content mt-2">
        <div [ngbNavOutlet]=" portalSendPropertiesNav"></div>
      </div>
    </div>
  </div>
  <div class="modal-footer bg-body pt-2 pb-2">
    <div class="hstack gap-2 justify-content-end">
      <button type="button" class="btn btn-soft-dark waves-effect waves-light"
        (click)="modal.close('Close click')">{{'t-close' | translate}}</button>
    </div>
  </div>

</ng-template>

<ng-template #contentContactNotification role="document" let-modal>
  <div class="modal-header bg-light  p-3">
    <h5 class="modal-title" id="topModalLabel">{{'t-potential-contacts' | translate}}</h5>
    <button type="button" class="btn-close " (click)="modal.dismiss('Cross click')">
    </button>
  </div>
  <div class="modal-body" *ngIf="selectedContacts?.contacts">
    <div class="table-responsive table-card">
      <table class="table">
        <thead>
          <tr class="bg-light text-muted">
            <th class="col-3">{{'t-name' | translate}}
            </th>
            <th class="col-3">{{'t-email' | translate}}
            </th>
            <th class="col-3">{{'t-phone' | translate}}
            </th>
            <th class="col-3 text-center">{{'t-new-contacts.t-compatibility' | translate}}
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let contact of selectedContacts?.contacts">
            <td>{{contact.name}}</td>
            <td>{{contact.email}}</td>
            <td>{{contact.phone}}</td>
            <td>
              <div class="circular-progress m-auto">
                <svg width="50" height="50" viewBox="0 0 36 36">
                  <!-- Fundo do círculo -->
                  <circle class="circle-bg" cx="18" cy="18" r="15.91549430918954" fill="none" stroke="#e6e6e6"
                    stroke-width="3"></circle>
                  <!-- Progresso -->
                  <circle class="circle-progress" cx="18" cy="18" r="15.91549430918954" fill="none"
                    [attr.stroke-dasharray]="getDash(contact.propertyQuality)"
                    [attr.stroke]="contact.propertyQuality < 33 ? '#dc3545' : contact.propertyQuality != 100 ? 'rgb(247, 184, 75)' : '#4caf50'"
                    stroke-width="3" stroke-linecap="round"></circle>
                </svg>
                <div
                  [style.color]="contact.propertyQuality < 33 ? '#dc3545' : contact.propertyQuality  != 100 ? 'rgb(247, 184, 75)' : '#4caf50'"
                  class="progress-text">{{
                  contact.propertyQuality }}%</div>
              </div>
            </td>
            <td>
              <button (click)="seeDetailsContact(contact, selectedContacts?.property, contentDetails)" type="button"
                class="btn btn-soft-info btn-sm">{{'t-see-details' |
                translate}}</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</ng-template>

<ng-template #contentDetails role="document" let-modal>
  <div class="modal-header bg-primary bg-primary-contacts  p-3">
    <h5 class="modal-title text-white" id="contactsModalLabel">{{'t-contact-info' | translate}}</h5>
    <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close" id="close-modal"
      (click)="modal.dismiss('Cross click')">
    </button>
  </div>
  <div *ngIf="contactSelected" class="modal-body">
    <div class="row p-details">
      <div class="col-lg-6">
        <div class="bg-light card rounded-3">
          <div class="card-body">
            <div class="d-flex align-items-center">
              <div class="align-items-center avatar-lg d-flex rounded">
                <img
                  src="{{contactSelected.image ? pathImage + contactSelected.image : 'assets/images/placeholder2.jpeg'}}"
                  alt="" class="member-img img-fluid d-block rounded">
              </div>
              <div class="ms-lg-3 my-3 my-lg-0 property-title">
                <h5 class="fs-14 mb-0">
                  {{ contactSelected.title.length > 20 ?
                  (contactSelected.title | slice:0:20) +
                  '...' : contactSelected.title }}
                </h5>
                <p class="text-muted mb-0">
                  {{contactSelected.reference}}</p>
              </div>
            </div>
            <div *ngIf="contactSelected?.fromMls" class="row">
              <h4 class="fs-16 col-12">{{'t-new-contacts.t-published-on-mls' | translate}}</h4>
              <div class="align-items-center d-flex">
                <div class="align-items-center avatar-md d-flex rounded col-12">
                  <img
                    src="{{contactSelected.entity.image ? pathLogoImage + contactSelected.entity.image : 'assets/images/placeholder2.jpeg'}}"
                    alt="" class="member-img img-fluid d-block">
                </div>
                <p class="ms-2 mb-0">
                  {{contactSelected.entity.name}}</p>
              </div>
            </div>
            <div class="property-details row">
              <div *ngIf="contactSelected.country" class="col-12 mb-3">
                <i class="ri-map-pin-line"></i> {{contactSelected.country}}<span *ngIf="contactSelected.district">,
                  {{contactSelected.district}}</span><span *ngIf="contactSelected.county">,
                  {{contactSelected.county}}</span><span *ngIf="contactSelected.parish">,
                  {{contactSelected.parish}}</span>
              </div>
              <div *ngIf="contactSelected.propertyType" class="col-12 mb-3">
                {{'t-new-contacts.t-type' | translate}}: {{contactSelected.propertyType}}
              </div>
              <div *ngIf="contactSelected.businessType" class="col-12 mb-3">
                {{'t-new-contacts.t-businessType' | translate}}: {{contactSelected.businessType}}
              </div>
              <div *ngIf="contactSelected.price" class="col-12 mb-3">
                {{'t-new-contacts.t-price' | translate}}: {{priceFormat(contactSelected.price,
                contactSelected?.currency)}}
              </div>
              <div *ngIf="contactSelected.propertyCondition" class="col-12 mb-3">
                {{'t-new-contacts.t-condition' | translate}}: {{contactSelected.propertyCondition}}
              </div>
              <div *ngIf="contactSelected?.businessStatus?.description" class="col-12 mb-3">
                {{'t-m-properties.t-business-status' | translate}}:
                {{contactSelected.businessStatus?.description}}
              </div>
              <div class="align-items-center col-12 d-flex mb-3">
                <span *ngIf="contactSelected?.bathrooms && contactSelected?.bathrooms != 0"
                  class="text-muted me-3 d-flex align-items-center"><i
                    ngbTooltip="{{'t-mls-filters.t-bathrooms' | translate}}" container="body" placement="top"
                    class="fw-normal mdi mdi-bathtub-outline me-2"
                    aria-hidden="true"></i>{{contactSelected.bathrooms}}</span>
                <span *ngIf="contactSelected?.bedrooms || contactSelected?.bedrooms == 0"
                  class="text-muted me-3 d-flex align-items-center">
                  <i ngbTooltip="{{'t-mls-filters.t-bedrooms' | translate}}" container="body" placement="top"
                    class="fs-4 fw-normal mdi mdi-bed-outline me-2" aria-hidden="true"></i>{{contactSelected.bedrooms}}
                </span>
              </div>
              <div class="col-12">
                <a target="_blank" [ngClass]="{'disabled': !contactSelected.status}"
                  [href]="generateMlsLink(contactSelected.title, contactSelected.uniqueId, contactSelected.siteLink)"
                  class="btn btn-soft-primary view-property-btn col-12 mb-2">{{'t-new-contacts.t-view-property-page'
                  |
                  translate}}</a>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="col-lg-6">
        <div class="contact-data row mb-3">
          <h3 class="fs-5 mb-3">{{'t-contact-info' | translate}}:</h3>
          <div *ngIf="contactSelected.name" class="col-12 mb-2">
            <p class="text-muted mb-0">{{'t-name' | translate}}:</p>
            <h5 class="fs-14 mb-0">{{contactSelected.name}}</h5>
          </div>
          <div *ngIf="contactSelected.email" class="col-12 mb-2">
            <p class="text-muted mb-0">{{'t-email' | translate}}:</p>
            <h5 class="fs-14 mb-0">{{contactSelected.email}}</h5>
          </div>
          <div *ngIf="contactSelected.phone" class="col-12 mb-2">
            <p class="text-muted mb-0">{{'t-phone' | translate}}:</p>
            <h5 class="fs-14 mb-0">{{contactSelected.phone}}</h5>
          </div>
        </div>
        <div class="attributes row">
          <h3 class="fs-5 mb-3">{{'t-contact-preferences' | translate}}:</h3>
          <div *ngIf="contactSelected?.propertyQuality" class="col-md-6">
            <div class="card card-animate overflow-hidden">
              <div class="position-absolute start-0" style="z-index: 0;">
                <svg version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 120" width="200" height="120">
                  <style>
                    .s0 {
                      opacity: .05;
                      fill: var(--vz-success)
                    }
                  </style>
                  <path id="Shape 8" class="s0"
                    d="m189.5-25.8c0 0 20.1 46.2-26.7 71.4 0 0-60 15.4-62.3 65.3-2.2 49.8-50.6 59.3-57.8 61.5-7.2 2.3-60.8 0-60.8 0l-11.9-199.4z">
                  </path>
                </svg>
              </div>
              <div class="card-body" style="z-index:1 ;">
                <div class="d-flex align-items-center">
                  <div class="flex-grow-1 overflow-hidden">
                    <p class="text-uppercase fw-medium text-muted mb-3">
                      {{'t-new-contacts.t-general-compatibility' | translate }}</p>
                    <!-- <h4 class="fs-22 fw-semibold ff-secondary mb-0"><span class="counter-value"
                                                data-target="4305">4,305</span></h4> -->
                  </div>
                  <div class="flex-shrink-0">
                    <div placement="top" class="circular-progress">
                      <svg width="50" height="50" viewBox="0 0 36 36">
                        <!-- Fundo do círculo -->
                        <circle class="circle-bg" cx="18" cy="18" r="15.91549430918954" fill="none" stroke="#e6e6e6"
                          stroke-width="3"></circle>
                        <!-- Progresso -->
                        <circle class="circle-progress" cx="18" cy="18" r="15.91549430918954" fill="none"
                          [attr.stroke-dasharray]="getDash(contactSelected.propertyQuality)"
                          [attr.stroke]="contactSelected.propertyQuality < 33 ? '#dc3545' : contactSelected.propertyQuality != 100 ? 'rgb(247, 184, 75)' : '#4caf50'"
                          stroke-width="3" stroke-linecap="round"></circle>
                      </svg>
                      <div
                        [style.color]="contactSelected.propertyQuality < 33 ? '#dc3545' : contactSelected.propertyQuality  != 100 ? 'rgb(247, 184, 75)' : '#4caf50'"
                        class="progress-text">{{
                        contactSelected.propertyQuality }}%</div>
                    </div>
                  </div>
                </div>
              </div><!-- end card body -->
            </div>
          </div>
          <div *ngIf="!contactSelected?.propertyQuality" class="col-md-6">
            <div class="card card-animate overflow-hidden">
              <div class="position-absolute start-0" style="z-index: 0;">
                <svg version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 120" width="200" height="120">
                  <style>
                    .s0 {
                      opacity: .05;
                      fill: var(--vz-warning)
                    }
                  </style>
                  <path id="Shape 8" class="s0"
                    d="m189.5-25.8c0 0 20.1 46.2-26.7 71.4 0 0-60 15.4-62.3 65.3-2.2 49.8-50.6 59.3-57.8 61.5-7.2 2.3-60.8 0-60.8 0l-11.9-199.4z">
                  </path>
                </svg>
              </div>
              <div class="card-body" style="z-index:1 ;">
                <div class="d-flex align-items-center">
                  <div class="flex-grow-1 overflow-hidden">
                    <p class="text-uppercase fw-medium text-muted mb-3">
                      {{'t-new-contacts.t-compatibility' | translate }}</p>
                  </div>
                  <div class="flex-shrink-0">
                    <div class="p-2 badge-soft-warning" container="body"
                      ngbTooltip="{{'t-new-contacts.t-no-interest-selected' | translate }}">
                      <i class="ri-alert-fill"></i>
                    </div>
                  </div>
                </div>
              </div><!-- end card body -->
            </div>
          </div>
          <div *ngFor="let attr of contactSelected.attrQuality" class="col-md-6">
            <ng-template #tooltipTpl>
              <div [innerHTML]="getTooltipText(attr?.key, contactSelected?.preferences)"></div>
            </ng-template>
            <div [ngbTooltip]="tooltipTpl" class="card card-animate overflow-hidden">
              <div class="position-absolute start-0" style="z-index: 0;">
                <svg version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 120" width="200" height="120">
                  <style>
                    .s0 {
                      opacity: .05;
                      fill: var(--vz-success)
                    }
                  </style>
                  <path id="Shape 8" class="s0"
                    d="m189.5-25.8c0 0 20.1 46.2-26.7 71.4 0 0-60 15.4-62.3 65.3-2.2 49.8-50.6 59.3-57.8 61.5-7.2 2.3-60.8 0-60.8 0l-11.9-199.4z">
                  </path>
                </svg>
              </div>
              <div class="card-body" style="z-index:1 ;">
                <div class="d-flex align-items-center">
                  <div class="flex-grow-1 overflow-hidden">
                    <p class="text-uppercase fw-medium text-muted mb-3">
                      {{attr.name | translate}}<i *ngIf="attr.isDefault" class="mdi mdi-information-outline"></i></p>
                    <!-- <h4 class="fs-22 fw-semibold ff-secondary mb-0"><span class="counter-value"
                                                data-target="4305">4,305</span></h4> -->
                  </div>
                  <div class="flex-shrink-0">
                    <div placement="top" class="circular-progress">
                      <svg width="50" height="50" viewBox="0 0 36 36">
                        <!-- Fundo do círculo -->
                        <circle class="circle-bg" cx="18" cy="18" r="15.91549430918954" fill="none" stroke="#e6e6e6"
                          stroke-width="3"></circle>
                        <!-- Progresso -->
                        <circle class="circle-progress" cx="18" cy="18" r="15.91549430918954" fill="none"
                          [attr.stroke-dasharray]="getDash(attr.value)"
                          [attr.stroke]="attr.value < 33 ? '#dc3545' : attr.value != 100 ? 'rgb(247, 184, 75)' : '#4caf50'"
                          stroke-width="3" stroke-linecap="round"></circle>
                      </svg>
                      <div
                        [style.color]="attr.value < 33 ? '#dc3545' : attr.value  != 100 ? 'rgb(247, 184, 75)' : '#4caf50'"
                        class="progress-text">{{
                        attr.value }}%</div>
                    </div>
                  </div>
                </div>
              </div><!-- end card body -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer bg-body pt-2 pb-2">
    <div class="hstack gap-2 justify-content-end">
      <a *ngIf="!contactSelected?.dealCreated" (click)="createDeal(contactSelected)"
        class="btn btn-soft-primary">{{'t-create-deal' | translate}}</a>
      <a *ngIf="!contactSelected?.addedToProperty" (click)="addContactToProperty(contactSelected)"
        class="btn btn-soft-success">{{'t-new-contacts.t-associate-to-contact' | translate}}</a>
      <a *ngIf="contactSelected?.addedToProperty" (click)="removeContactFromProperty(contactSelected)"
        class="btn btn-soft-danger">{{'t-new-contacts.t-remove-from-contact' | translate}}</a>
      <button type="button" class="btn btn-soft-dark waves-effect waves-light" data-bs-dismiss="modal"
        (click)="modal.close('Close click')">{{'t-close' | translate}}</button>
    </div>
  </div>
</ng-template>

